import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';

@Entity()
export class InstitutionMailLog extends MongoEntity {
  static override _class = 'InstitutionMailLog';
  static override _collectionName = 'institution-mail-logs';

  @Field(type => String)
  mailTemplate!: string;

  @Field(type => Date)
  timestamp?: Date;

  @Field(type => String)
  insitutionID!: string;

  @Field(type => String)
  email!: string;
}
